import { render, staticRenderFns } from "./editFence.vue?vue&type=template&id=4915c83e&scoped=true&"
import script from "./editFence.vue?vue&type=script&lang=js&"
export * from "./editFence.vue?vue&type=script&lang=js&"
import style0 from "./editFence.vue?vue&type=style&index=0&id=4915c83e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4915c83e",
  null
  
)

component.options.__file = "editFence.vue"
export default component.exports